import logisticsApi from "./logisticsApi";

export async function putCoverageAreaDrivers(
  dealerId: string,
  coverageAreaId: string,
  selectedDriverIdsInOrder: string[],
): Promise<void> {
  await logisticsApi.put(
    `/v1/dealers/${dealerId}/coverage-areas/${coverageAreaId}/drivers`,
    {
      drivers: selectedDriverIdsInOrder.map((driverId, priority) => ({
        driverId,
        priority,
      })),
    },
  );
}
